module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("To Catch a Thief")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "frm01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle1"
  })]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("Dear Reader,")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("Some characters you never forget.")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("Some stories grip you from the first word, locked deep in the heart. For me, that love struck with a great gray cat, a brooding English abbey and its aristocratic guardian ghost, Adrian Draycott.")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("I’ve walked through eight books and two novellas set at the abbey now. Each story brings more secrets and the heady scent of rich heritage roses climbing up tower and parapet.")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("Dangerous magic.")])]), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', [_vm._v("White-hot passion.")])]), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', [_vm._v("Undying love.")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("How could any writer resist?")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("And just to keep the tension hot, I’ve brought a rugged Navy SEAL from my Code Name series to the abbey, locked in pursuit of a vicious enemy.")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("I hope you enjoy the adventure.")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("See you at the abbey.")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Christina")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-409fc313","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tocatchathief_frm01.vue
// module id = 66
// module chunks = 0